import moment from "moment-timezone";
import Vue from 'vue';
import stringSimilarity from 'string-similarity'

export default {
    computed: {
        formPages() {
            return this.$store.getters[`${this.formStore}/form/formPages`]
        },
        form() {
            return this.$store.getters[`${this.formStore}/form/get`]
        },
        core() {
            return this.$store.getters[`${this.formStore}/core/get`]
        },
        credentials() {
            return this.$store.getters[`${this.formStore}/core/credentials`]
        },
        authenticated() {
            return this.$store.getters[`${this.formStore}/core/authenticated`]
        },
        loginUrl() {
            return this.$store.getters[`${this.formStore}/core/loginUrl`]
        },
        resendUrl() {
            return this.$store.getters[`${this.formStore}/core/resendUrl`]
        },
        formFieldBlacklist() {
            return this.$store.getters[`${this.formStore}/form/formFieldBlacklist`]
        },
        currentField() {
            return this.$store.getters[`${this.formStore}/form/currentField`]
        },
        currentGroup() {
            return this.$store.getters[`${this.formStore}/form/currentGroup`]
        },
        rulesModal() {
            return this.$store.getters[`${this.formStore}/form/rulesModal`]
        },
        searchObjects() {
            return this.$store.getters[`${this.formStore}/core/searchObjects`]
        },
        isFrontend() {
            return this.$store.getters[`${this.formStore}/form/frontend`]
        },
        frontendData() {
            return this.$store.getters[`${this.formStore}/form/frontendData`]
        },
        changingPage: {
            get() {
                return this.$store.getters[`${this.formStore}/form/changingPage`]
            },
            set(changingPage) {
                this.$store.dispatch(`${this.formStore}/form/setChangingPage`, changingPage)
            }
        },
        changingPageForward: {
            get() {
                return this.$store.getters[`${this.formStore}/form/changingPageForward`]
            },
            set(changingPageForward) {
                this.$store.dispatch(`${this.formStore}/form/setChangingPageForward`, changingPageForward)
            }
        },
        checkRulesTimeout: {
            get() {
                return this.$store.getters[`${this.formStore}/form/checkRulesTimeout`]
            },
            set(rulesTimeout) {
                this.$store.dispatch(`${this.formStore}/form/setCheckRulesTimeout`, rulesTimeout)
            }
        },
        checkRulesTimeoutWait: {
            get() {
                return this.$store.getters[`${this.formStore}/form/checkRulesTimeoutWait`]
            },
            set(rulesTimeoutWait) {
                this.$store.dispatch(`${this.formStore}/form/setCheckRulesTimeoutWait`, rulesTimeoutWait)
            }
        },
        formFields: {
            get() {
                return this.$store.getters[`${this.formStore}/form/formFields`]
            },
            set(fields) {
                this.$store.dispatch(`${this.formStore}/form/setFormFields`, fields)
            }
        },
        formData: {
            get() {
                return this.$store.getters[`${this.formStore}/form/formData`]
            },
            set(formData) {
                this.$store.dispatch(`${this.formStore}/form/setFormData`, formData)
            }
        },
        currentPage: {
            get() {
                return this.$store.getters[`${this.formStore}/form/currentPage`]
            },
            set(currentPage) {
                this.$store.dispatch(`${this.formStore}/form/setCurrentPage`, currentPage)
            }
        },
        totalPages() {
            let totalPages = 0
            this.formPages.forEach(formPage => {
                if (_.isArray(formPage)) {
                    totalPages++
                }
            })
            return totalPages
        },
        currentPageData() {
            return _.get(this.formPages, this.currentPage, null)
        },
        currentPageName() {
            let currentPageData = this.formPages[this.currentPage]
            return _.isPlainObject(currentPageData) || _.isArray(currentPageData) ? "form" : currentPageData
        },
        changingPageClass() {
            if (this.changingPageForward) {
                if (this.changingPage) {
                    return "fin-animate-hidePage"
                }
                return "fin-animate-showPage"
            } else {
                if (this.changingPage) {
                    return "fin-animate-hidePageReverse"
                }
                return "fin-animate-showPageReverse"
            }
        },
        formGroups() {

            let formGroups = _.get(this.form.form_config, 'groups', [])

            let applicationTypeId = Number(_.get(this.formData, 'application.application_type_id', 0))
            if (applicationTypeId) {
                formGroups = formGroups.filter(formGroup => {
                    return !_.has(formGroup, 'appType') || _.isNull(formGroup.appType) || Number(formGroup.appType) === applicationTypeId
                })
            }

            if (_.isEmpty(formGroups)) return []

            if (this.core.hasQuote && _.isEmpty(formGroups.filter(formGroup => _.has(formGroup, 'inject', false) && formGroup.inject == "quote"))) {
                formGroups.push({
                    description: "Select your preferred loan from a list of personalised lenders",
                    icon: "far fa-book-reader",
                    name: "",
                    title: "Your Quote",
                    inject: 'quote'
                })
            }

            if (_.isEmpty(formGroups.filter(formGroup => _.has(formGroup, 'inject', false) && formGroup.inject == "final"))) {
                formGroups.push({
                    description: "Read terms and conditions and sign a privacy statement",
                    icon: "fas fa-signature",
                    name: "",
                    title: "Your Signature",
                    inject: 'final'
                })
            }

            return formGroups
        },

        groupRules() {

            let groupRules = []

            // check to see if the input group has an active rule set
            let ruleActive = (rule) => {
                if (rule.field != "" &&
                    rule.operator != "" &&
                    rule.type != "" &&
                    rule.value != "") {
                    return true
                }
                return false
            }

            // generate subfields
            const generateSubFields = (field) => {
                let subFieldGroupRules = []
                if (!_.isEmpty(field.subFields)) {
                    field.subFields.forEach(subField => {
                        if (_.has(subField, 'subFields', false)) {
                            if (subField.type == "inputGroup") {
                                let rules = Object.assign([], subField.rule)
                                rules.forEach((rule, ruleKey) => {
                                    if (ruleActive(rule)) {
                                        let theRule = Object.assign({}, rule)
                                        theRule.group = Object.assign({}, subField)
                                        subFieldGroupRules.push(theRule)
                                    }
                                })
                            }
                            if (!_.isEmpty(subField.subFields)) {
                                let subFieldRules = generateSubFields(subField)
                                if (!_.isEmpty(subFieldRules)) {
                                    subFieldGroupRules = [...subFieldGroupRules, ...subFieldRules]
                                }
                            }
                        }
                    })
                }
                return subFieldGroupRules
            }

            // return empty array if there are no form fields
            if (!_.isEmpty(this.formFields)) {
                Object.assign([], this.formFields).forEach(field => {
                    if (_.has(field, 'subFields', false)) {
                        if (field.type == "inputGroup") {
                            let rules = Object.assign([], field.rule)
                            rules.forEach((rule, ruleKey) => {
                                if (ruleActive(rule)) {
                                    let theRule = Object.assign({}, rule)
                                    theRule.group = Object.assign({}, field)
                                    groupRules.push(theRule)
                                }
                            })
                        }
                        if (!_.isEmpty(field.subFields)) {
                            let subFieldRules = generateSubFields(field)
                            if (!_.isEmpty(subFieldRules)) {
                                groupRules = [...groupRules, ...subFieldRules]
                            }
                        }
                    }
                })
            }

            return groupRules
        },
    },
    watch: {

        "formData.application.application_type_id": _.debounce(function (applicationTypeId) {
            let originalForm = this.$store.getters[`${this.formStore}/form/originalForm`]
            this.$store.dispatch(`${this.formStore}/form/setFormPages`, originalForm)
        }, 100),

        currentPage: {
            handler(currentPage, previousPage) {
                if (currentPage !== previousPage && typeof previousPage !== "undefined" && !_.isString(this.currentPageData) && this.currentPageData != null) {
                    let pageGroup = this.currentPageData.filter(pageData => {
                        if (_.has(pageData, 'group.id') && !_.isNull(pageData.group.id)) {
                            return pageData
                        }
                    })

                    let currentGroup = _.get(pageGroup, '0.group', [])
                    if (!_.isEmpty(currentGroup)) {
                        this.$store.dispatch(`${this.formStore}/form/setCurrentGroup`, currentGroup)
                    }
                }
            },
            immediate: true
        },

        changingPage: {
            handler(changingPage) {
                if (changingPage) {
                    setTimeout(() => {
                        this.changingPage = !changingPage
                    }, 1000)
                }
            },
            immediate: true
        },
    },
    methods: {
        getStarted() {
            this.changingPage = true
            this.changingPageForward = true

            axios
                .post(`/app-form/${this.$route.params.applicant}/application/${this.$route.params.application}/${this.$route.params.formType}/get-started`, {
                    currentPage: this.currentPage,
                    currentPageName: this.currentPageName,
                    totalPages: this.totalPages,
                    quoteActive: this.core.hasQuote,
                    changingPageForward: this.changingPageForward
                }, {
                    headers: {
                        Authorization: `Bearer ${this.core.token}`,
                    }
                })
                .then(res => {
                    this.$store.dispatch(`${this.formStore}/core/setFastTrackActive`, _.get(res, 'data.fastTrackActive'))
                })
                .catch(err => console.error(err))
                .finally(() => {

                })

            setTimeout(() => {
                this.currentPage = 1
                this.changingPage = false
            }, 495)

        },
        download(dataURL) {
            let blob = this.dataURLToBlob(dataURL)
            return blob
        },
        dataURLToBlob(dataURL) {
            var parts = dataURL.split(";base64,")
            var contentType = parts[0].split(":")[1]
            var raw = window.atob(parts[1])
            var rawLength = raw.length
            var uInt8Array = new Uint8Array(rawLength)

            for (var i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i)
            }

            return new Blob([uInt8Array], { type: contentType })
        },

        saveForm(submitData) {

            submitData = typeof submitData !== 'undefined' ? submitData : false
            this.$store.dispatch(`${this.formStore}/form/setNavigationActive`, false)

            let saveForFuture = document.getElementById('saveForFuture')

            let saveFormData = this.$store.getters[`${this.formStore}/form/saveFormData`]

            let formPostData = new FormData()

            formPostData.append('saveFormData', JSON.stringify(saveFormData))

            let targetPage = _.get(this.formPages, this.currentPage + 1)
            targetPage = _.isArray(targetPage) ? 'form' : targetPage
            formPostData.append('targetPage', JSON.stringify(targetPage, false))
            formPostData.append('currentPage', JSON.stringify(this.currentPage, false))
            formPostData.append('currentPageName', JSON.stringify(this.currentPageName, false))
            formPostData.append('changingPageForward', this.changingPageForward)

            if (submitData) {
                let type = this.submitData.signatureData.signatureType == "draw" ? 1 : 0
                let sig = this.download(this.submitData.signatureData.signature)
                formPostData.append('submitData', JSON.stringify(submitData))
                formPostData.append('signatureType', type)
                formPostData.append('signatureBlob', sig)
                formPostData.append('creditCheck', this.core.creditCheck)
                formPostData.append('formFields', JSON.stringify(this.formFields))
                formPostData.append('formData', JSON.stringify(this.formData))
            }

            if (saveForFuture && saveForFuture.value === 'Yes') {
                let type = this.submitData.signatureData.signatureType == "draw" ? 1 : 0
                let sig = this.download(this.submitData.signatureData.signature)

                let formData = new FormData()

                formData.append('signature_blob', sig);
                formData.append('name', $('#name').val());
                formData.append('date', moment().format('YYYY-MM-DD'));
                formData.append('signature_type', type);

                axios
                    .post(this.$store.getters[`${this.formStore}/form/saveReusableSignature`], formData, {
                        headers: {
                            Authorization: `Bearer ${this.core.token}`,
                            "Content-Type": "multipart/form-data",
                        }
                    })
                    .then(res => {

                    })
                    .catch(err => {
                        console.error(err)
                    })
                    .finally(() => {
                    })
            }

            axios
                .post(`/app-form/${_.get(this.$route, 'params.coreProp.applicant.id', this.$route.params.applicant)}/application/${_.get(this.$route, 'params.coreProp.application.id', this.$route.params.application)}/${this.$route.params.formType}/save-app-form`, formPostData, {
                    headers: {
                        Authorization: `Bearer ${this.core.token}`,
                        "Content-Type": "multipart/form-data",
                    }
                })
                .then(res => {

                    if (submitData) {
                        this.$store.dispatch(`${this.formStore}/core/updateApplication`, _.get(res, 'data.application'))
                        this.$store.dispatch(`${this.formStore}/core/updateCustomFields`, _.get(res, 'data.customFields'))
                        this.$store.dispatch(`${this.formStore}/core/updateObjectives`, _.get(res, 'data.objectives'))

                        let timeline = _.get(res, 'data.timeline', false)
                        let hasSuccessPage = _.get(res, 'data.hasSuccessPage', false)
                        let successPage = _.get(res, 'data.successPage', false)

                        if (hasSuccessPage && successPage) {
                            window.location.href = successPage
                        } else {
                            window.location.href = timeline
                        }
                    } else {
                        this.$store.dispatch(`${this.formStore}/core/updateApplication`, _.get(res, 'data.application'))
                        this.$store.dispatch(`${this.formStore}/core/updateCustomFields`, _.get(res, 'data.customFields'))
                        this.$store.dispatch(`${this.formStore}/core/updateObjectives`, _.get(res, 'data.objectives'))
                        this.$store.dispatch(`${this.formStore}/core/setAuthenticated`, _.get(res, 'data.authenticated', false))
                        this.$store.dispatch(`${this.formStore}/core/setLoginUrl`, _.get(res, 'data.loginUrl', null))
                        this.$store.dispatch(`${this.formStore}/core/setResendUrl`, _.get(res, 'data.resendUrl', null))

                        this.setFormFields(this.formFields)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
                .finally(() => {
                    this.$store.dispatch(`${this.formStore}/form/setNavigationActive`, true)
                })
        },

        setCurrentField(field) {
            this.$store.dispatch(`${this.formStore}/form/setCurrentField`, field)
        },

        fieldProp(field) {
            let fieldId = this.getFieldId(field, true)
            fieldId = fieldId.split('.')
            if (_.size(fieldId) > 1) {
                fieldId = fieldId[_.size(fieldId) - 1]
            } else {
                fieldId = fieldId[0]
            }
            return fieldId
        },

        getFieldId(field, forceString = false) {

            let fieldId
            if (!_.isEmpty(field.field_mapping)) {
                fieldId = field.field_mapping
            } else if (!_.isEmpty(field.name)) {
                fieldId = field.name
            } else {
                fieldId = field.id
            }

            if (typeof forceString != "undefined" && forceString) {
                return String(fieldId)
            }
            return fieldId
        },

        getFieldType(field) {
            switch (_.get(field, 'type', null)) {
                case "pageColumns":
                    return "Column"
                    break;
                case "inputGroup":
                    return "Group"
                    break;
                case "pageTitle":
                    return "Title"
                    break;
                default:
                    return "Field"
                    break;
            }
        },
        hasConditions(field) {
            // get the field conditionals
            let fieldConditionals = _.get(field, 'conditional_logic', [])
            return !_.isEmpty(fieldConditionals) ? true : false
        },
        checkRules(field, path) {

            // only run if we have found some groups with rules
            if (!_.isEmpty(this.groupRules)) {

                // wait until the user stops typing for 1 second
                if (this.checkRulesTimeout) clearTimeout(this.checkRulesTimeout)
                this.checkRulesTimeout = setTimeout(() => {

                    // get the rule if the field has one assigned
                    let fieldRule = this.groupRules.find(rules => {

                        let fieldRuleArray = (rules.field).split('-')
                        if (!_.isEmpty(fieldRuleArray)) {
                            return fieldRuleArray[1] == this.getFieldId(field)
                        }
                    })

                    if (fieldRule && !_.isEmpty(fieldRule)) {

                        // get this group id of the field rule
                        let groupRules = this.groupRules.filter(groupRule => this.getFieldId(groupRule.group) == this.getFieldId(fieldRule.group))

                        if (!_.isEmpty(groupRules)) {
                            let groupRulesPassed = []
                            let ruleData = []
                            let repeatRequired = false

                            // loop through each group rule and get the required check data
                            groupRules.forEach((condition) => {

                                let conditionKeyArray = condition.field.split('.')
                                let conditionKey = conditionKeyArray[_.size(conditionKeyArray) - 1]

                                // get the path to the data
                                let conditionPath = this.findPath({
                                    obj: this.formData,
                                    key: conditionKey,
                                    parent: field.field_mapping_parent
                                })

                                // get the data for field
                                let data = _.get(this.formData, conditionPath[0], false)
                                ruleData.push(data ? {
                                    data: data,
                                    condition: condition
                                } : false)
                            })

                            // only check the rules if there is data for all rules
                            if (!_.isEmpty(ruleData) && !ruleData.includes(false)) {
                                ruleData.forEach(rule => {
                                    // check if the string is numerical and convert if needed
                                    if (!isNaN(rule.data) && !isNaN(parseFloat(rule.data))) {
                                        rule.data = Number(rule.data)
                                    }
                                    // check if the string is numerical and convert if needed
                                    if (!isNaN(rule.condition.value) && !isNaN(parseFloat(rule.condition.value))) {
                                        rule.condition.value = Number(rule.condition.value)
                                    }
                                    // create the rule
                                    let ruleArray = [rule.data, rule.condition.operator, rule.condition.value]
                                    // create the test
                                    const test = ruleArray.map((e, i) => {
                                        let isOperator = i === 1
                                        return !isOperator ? this.setType(e) : e
                                    }).join(" ")
                                    // run the test
                                    let testResult = eval(test)
                                    // push the results
                                    groupRulesPassed.push(testResult)
                                })
                            }

                            // check that all conditions have been met
                            if (!_.isEmpty(groupRulesPassed)) {
                                repeatRequired = !groupRulesPassed.includes(false)
                                if (repeatRequired) {
                                    let groupField = _.get(groupRules, '0.group', false)
                                }
                            }
                        }
                    }
                }, this.checkRulesTimeoutWait)
            }
        },

        conditionallyActive(field, path) {

            let conditionallyActive = true
            let rule

            // get the field conditionals
            let fieldConditionals = Object.assign([], _.get(field, 'conditional_logic', []))
            let conditionalMethod = _.get(field, 'conditional_method', 'and')

            // only continue if we have some field conditionals
            if (!_.isEmpty(fieldConditionals)) {

                // empty array for test results
                let results = []

                // loop the conditionals
                fieldConditionals.forEach((condition) => {
                    let fieldArray, fieldId
                    let conditionField = condition.field
                    let conditionOperator = condition.operator
                    let conditionType = condition.type
                    let conditionValue = String(condition.value)

                    if (conditionField) {
                        fieldArray = conditionField.split('-')
                        if (_.size(fieldArray) > 1) {
                            fieldId = fieldArray[0]
                            conditionField = fieldArray[1]
                        } else {
                            fieldId = conditionField = fieldArray[0]
                        }
                    }

                    let canProceed = false

                    if (conditionOperator == 'notEmpty') {
                        canProceed = !_.isEmpty(conditionField)
                    } else {
                        canProceed = !_.isEmpty(conditionField) && !_.isEmpty(conditionOperator) && !_.isEmpty(conditionType) && !_.isEmpty(conditionValue)
                    }

                    // check to see if the condition is complete and not inactive
                    if (canProceed) {

                        let conditionFieldArray = conditionField.split('.')
                        if (_.size(conditionFieldArray) == 2) {
                            conditionField = conditionFieldArray[1]
                            path = `${path}.${conditionFieldArray[0]}`
                        }

                        // find the path to the condtion field
                        let conditionPath = this.findPath({
                            obj: this.formData,
                            key: conditionField,
                            parent: path
                        })

                        if (!_.isEmpty(conditionPath)) {

                            conditionPath.forEach((path, pathKey) => {

                                let testResult = false
                                let pathData = _.get(this.formData, path, null) || null

                                if (conditionOperator == 'notEmpty') {
                                    pathData = _.isInteger(pathData) ? String(pathData) : pathData
                                    testResult = !_.isEmpty(pathData)

                                } else {

                                    // create the condition rule
                                    rule = [pathData, conditionOperator, conditionValue]

                                    // create the test for the condition tile
                                    const test = rule.map((e, i) => {
                                        let isOperator = i === 1
                                        return !isOperator ? `"${e}"` : e
                                    }).join(" ")

                                    // run the test and push the results
                                    testResult = eval(test)
                                }

                                results.push(testResult)

                            })
                        }
                    }
                })

                if (conditionalMethod == 'and') {
                    // return true if all tests have passed
                    conditionallyActive = !results.includes(false)
                } else if (conditionalMethod == 'or') {
                    // return true if at least 1 test has passed
                    conditionallyActive = results.some(result => result)
                }

                return conditionallyActive

            }

            // show the field by default
            return true
        },

        getPathData(field, filter, isField = true) {

            let fieldId

            // is field with a value of false will treat field like a key
            if (typeof isField !== "undefined" && !isField) {
                fieldId = field
            } else {
                fieldId = this.getFieldId(field)
                let fieldIdArray = String(fieldId).split(".")
                if (_.size(fieldIdArray) > 1) {
                    fieldId = fieldIdArray[_.size(fieldIdArray) - 1]
                } else {
                    fieldId = fieldIdArray[0]
                }
            }

            let searchPath = this.findPath({
                obj: this.formData,
                key: fieldId,
                parent: field.field_mapping_parent
            })

            let path

            if (filter) {
                path = searchPath.find(data => data.includes(filter))
            } else {
                path = searchPath[0]
            }

            return _.get(this.formData, path, null)
        },

        findPath(options) {

            let results = [];

            (function findKey({
                key,
                obj,
                pathToKey,
            }) {

                const oldPath = `${pathToKey ? pathToKey + "." : ""}`;

                if (obj && obj.hasOwnProperty(key)) {
                    let path = `${oldPath}${key}`
                    results.push(path)
                    return;
                }

                if (obj !== null && typeof obj === "object" && !Array.isArray(obj)) {
                    for (const k in obj) {
                        if (obj.hasOwnProperty(k)) {
                            if (Array.isArray(obj[k])) {
                                for (let j = 0; j < _.size(obj[k]); j++) {
                                    findKey({
                                        key,
                                        obj: obj[k][j],
                                        pathToKey: `${oldPath}${k}.${j}`,
                                    });
                                }
                            } else if (obj[k] !== null && typeof obj[k] === "object") {
                                findKey({
                                    key,
                                    obj: obj[k],
                                    pathToKey: `${oldPath}${k}`,
                                });
                            }
                        }
                    }
                }
            })(options);

            if (options.parent.includes('application.applicants.0')) {
                results = results.filter(result => {
                    return result.includes('application.applicants.0')
                })
            } else if (options.parent.includes('application.applicants.1')) {
                results = results.filter(result => {
                    return result.includes('application.applicants.1')
                })
            }

            if (options.parent && _.size(results) > 1) {
                let bestMatchObject = stringSimilarity.findBestMatch(options.parent, results)
                results = results[bestMatchObject.bestMatchIndex] ? [results[bestMatchObject.bestMatchIndex]] : results
            }

            return results;
        },
        setType(e) {
            if (typeof e === 'string') {
                return `"${e}"`
            } else if (typeof e === 'number') {
                return e
            }
            return e
        },
        searchById(id, items) {
            items = typeof items !== "undefined" ? items : this.formFields
            var i = 0, found, result = {};
            for (; i < _.size(items); i++) {
                if (this.getFieldId(items[i]) === id) {
                    result = items[i]
                } else if (_.isArray(items[i].subFields)) {
                    found = this.searchById(id, items[i].subFields);
                    if (_.size(found)) {
                        result = found
                    }
                }
            }
            return result;
        },

        setFormFields(fields) {
            // start with empty form data object
            let formData = {}
            if (this.isFrontend && !_.isEmpty(this.frontendData)) {
                formData = this.frontendData
            } else if (!this.isFrontend) {
                formData = {
                    application: this.core.application,
                    customFields: this.core.customFields
                }
            }
            this.$store.dispatch(`${this.formStore}/form/setFormData`, formData)
        },

        generateSubFields(field, fieldData) {

            // set the empty field type based on the
            // type of data we are passing
            let generatedSubFieldData = _.isArray(fieldData) ? [] : (_.isNull(field.field_mapping) ? [] : {})

            // continue if the subfields is not empty
            if (!_.isEmpty(field.subFields)) {

                // loop through the subfields
                field.subFields.forEach((subField, subFieldKey) => {

                    // only get data related fields
                    if (!this.formFieldBlacklist.includes(subField.type)) {

                        // turn a comma seperated sub field mapping into an array
                        let subFieldMapping
                        let subFieldMappingArray = subField.field_mapping ? subField.field_mapping.split(",") : []
                        if ([0, 1].includes(_.size(subFieldMappingArray))) {
                            subFieldMapping = subField.field_mapping
                        } else {
                            subFieldMapping = subFieldMappingArray.map(subFieldMapping => subFieldMapping.trim())
                        }

                        // check to see if the subField has subfields so we can create a loop
                        let hasSubFields = _.has(subField, "subFields", false) && !_.isEmpty(subField.subFields)

                        // if there are subfields generate the subfield data,
                        // otherwise try and map the data
                        if (hasSubFields) {

                            // if the sub field is page columns
                            if (subField.type == "pageColumns") {

                                // console.warn('here 5', this.getFieldId(subField))

                                // inject the parent mapping into the page column as columns don't have mappings
                                subField.field_mapping = field.field_mapping

                                // set the mapped data if any
                                if (_.isArray(generatedSubFieldData)) {

                                    // loop through each in the array
                                    fieldData.forEach((subFieldData, key) => {

                                        // get the subfield data
                                        subFieldData = _.get(subFieldData, subField.field_mapping, fieldData)
                                        let generatedColumn = this.generateSubFields(subField, subFieldData)

                                        generatedColumn.forEach((generated, generatedKey) => {
                                            if (key == generatedKey) {

                                                let currentData = _.get(generatedSubFieldData, key)

                                                _.set(generatedSubFieldData, key, _.merge(currentData, generated))

                                                // console.warn('5 array', key, _.merge(currentData, generated))

                                            }
                                        })
                                    })

                                } else {
                                    if (!_.isEmpty(subField.subFields)) {
                                        let subFieldData = _.get(fieldData, subField.field_mapping, fieldData)

                                        let subFieldsData = this.generateSubFields(subField, subFieldData)

                                        generatedSubFieldData = _.merge(generatedSubFieldData, subFieldsData)

                                        // console.warn('5 sub', {...generatedSubFieldData, ...subFieldsData})

                                    } else {
                                        let subFieldData = _.get(fieldData, subField.field_mapping, fieldData)
                                        generatedSubFieldData = this.generateSubFields(subField, subFieldData)

                                        // console.warn('5', generatedSubFieldData)
                                    }
                                }
                            } else {
                                // set the mapped data if any
                                if (_.isArray(generatedSubFieldData)) {

                                    // console.warn('here 4', this.getFieldId(subField))

                                    fieldData.forEach((subFieldData, key) => {

                                        // console.warn('subFieldData', subFieldData)

                                        subFieldData = _.get(subFieldData, subField.field_mapping, fieldData)
                                        let subFields = this.generateSubFields(subField, subFieldData)

                                        // console.warn('subField.field_mapping', subField.field_mapping, subFieldData)

                                        // if not these fields, append the id
                                        if (![
                                            'aai.other_income',
                                            'aai.expenses_general',
                                            'aai.expenses_discretionary',
                                            'aai.expenses_transport',
                                            'aai.expenses_other',
                                            'aai.asset_liabilities',
                                            // 'liability',
                                            // 'rent',
                                            'investment_properties',
                                            'aai.dependents',
                                        ].includes(subField.field_mapping)) {
                                            if (!_.isEmpty(subFieldMapping)) {
                                                if (_.isArray(subFields)) {
                                                    if (_.isEmpty(subFields)) {
                                                        subFields.push({
                                                            id: _.get(subFieldData, 'id', null)
                                                        })
                                                    }
                                                } else {
                                                    _.set(subFields, 'id', _.get(subFieldData, 'id', null))
                                                }
                                            }
                                        }

                                        let currentData = this.getPathData(subField, `${key}.${this.getFieldId(subField)}`)
                                        let updatedData = []

                                        if (_.isArray(subFields) && !_.isEmpty(currentData)) {

                                            subFields.forEach((subSubField, subSubFieldKey) => {
                                                updatedData[subSubFieldKey] = _.mergeWith({}, currentData[subSubFieldKey], subSubField, (a, b) => b === null ? a : undefined)
                                            })

                                            _.set(generatedSubFieldData, `${key}.${this.getFieldId(subField)}`, updatedData)
                                        } else {
                                            _.set(generatedSubFieldData, `${key}.${this.getFieldId(subField)}`, subFields)
                                        }
                                    })

                                } else {

                                    // console.warn('here 3', this.getFieldId(subField))

                                    let subFieldData = _.get(fieldData, subField.field_mapping, fieldData)
                                    let subFields = this.generateSubFields(subField, subFieldData)

                                    if (_.isArray(subFields)) {
                                        if (_.isEmpty(subFields)) {
                                            if (!_.isEmpty(subFieldMapping)) {
                                                subFields.push({
                                                    id: _.get(subFieldData, 'id', null)
                                                })
                                            }
                                        } else {
                                            subFields.forEach((subSubField, subSubFieldKey) => {

                                                if (!_.isEmpty(subFieldMapping)) {
                                                    subSubField.id = _.get(subFieldData, `${subSubFieldKey}.id`, null)
                                                }

                                                // inject the aai id if the sub field has aai
                                                if (_.has(subSubField, 'aai', false)) {
                                                    let applicants = _.get(fieldData, subField.field_mapping, fieldData)
                                                    let aaiId = _.get(applicants, `${subSubFieldKey}.aai.id`, null)
                                                    _.set(subFields, `${subSubFieldKey}.aai.id`, aaiId)
                                                }
                                            })
                                        }
                                    } else {
                                        if (!_.isEmpty(subFieldMapping)) {
                                            _.set(subFields, 'id', _.get(subFieldData, 'id', null))
                                        }
                                    }

                                    _.set(generatedSubFieldData, `${this.getFieldId(subField)}`, subFields)

                                    // console.warn('3', `${this.getFieldId(subField)}`, subFields)
                                }
                            }

                        } else {

                            // set the mapped data if any
                            if (_.isArray(generatedSubFieldData)) {

                                // console.warn('here 2', this.getFieldId(subField))

                                fieldData.forEach((item, key) => {

                                    if (!_.isEmpty(subFieldMapping)) {
                                        if (field.field_mapping == 'aai.asset_liabilities') {
                                            _.set(generatedSubFieldData, `${key}.id`, key)
                                            _.set(generatedSubFieldData, `${key}.reference`, _.get(item, 'reference', null))
                                        } else if (field.field_mapping == 'investment_properties') {
                                            _.set(generatedSubFieldData, `${key}.id`, _.get(item, 'id', null))
                                            _.set(generatedSubFieldData, `${key}.asset_liability`, _.get(item, 'asset_liability', {}))
                                            _.set(generatedSubFieldData, `${key}.asset_liability_income`, _.get(item, 'asset_liability_income', {}))
                                        } else if (field.field_mapping == 'aai.other_income') {
                                            _.set(generatedSubFieldData, `${key}.id`, _.get(item, 'id', null))
                                            _.set(generatedSubFieldData, `${key}.investmentProperty`, _.get(item, 'investmentProperty', null))
                                            _.set(generatedSubFieldData, `${key}.address_client_id`, _.get(item, 'address_client_id', null))
                                            _.set(generatedSubFieldData, `${key}.incomeType`, _.get(item, 'incomeType', null))
                                        } else if (field.field_mapping == 'aai.dependents') {
                                            _.set(generatedSubFieldData, `${key}.id`, _.get(item, 'id', null))
                                        } else {
                                            _.set(generatedSubFieldData, `${key}.id`, _.get(item, 'id', null))
                                        }
                                    }

                                    if (this.getFieldId(subField) == 'formatted_address') {

                                        let addressFields = {
                                            id: item.id,
                                            formatted_address: item.formatted_address,
                                            unit_number: item.unit_number,
                                            street_number: item.street_number,
                                            route: item.route,
                                            locality: item.locality,
                                            administrative_area_level_1: item.administrative_area_level_1,
                                            administrative_area_level_2: item.administrative_area_level_2,
                                            postal_code: item.postal_code,
                                            country: item.country,
                                        }

                                        Object.entries(addressFields).forEach((itemEntry, itemEntryKey) => {
                                            let generatedFieldData = _.get(item, itemEntry[0], null)
                                            _.set(generatedSubFieldData, `${key}.${itemEntry[0]}`, generatedFieldData)
                                        })

                                    } else {
                                        if (_.isArray(subFieldMapping)) {
                                            subFieldMapping.forEach((subMap) => {
                                                let generatedFieldData = _.get(item, subMap, null)
                                                _.set(generatedSubFieldData, `${key}.${subMap}`, generatedFieldData)

                                                // console.warn('2 array', `${key}.${subMap}`, generatedFieldData)
                                            })
                                        } else {

                                            let generatedFieldData = _.get(item, subField.field_mapping, null)

                                            // console.warn('2 generatedFieldData', generatedFieldData, subField.field_mapping, subField.field_mapping_parent, item)

                                            if (['split', 'reference_address'].includes(subField.field_mapping)) {
                                                if (_.isEmpty(generatedFieldData) || _.isNull(generatedFieldData) || !generatedFieldData) {
                                                    generatedFieldData = {}
                                                }
                                            }



                                            // force boolean to be '1' or '0'
                                            if (this.getFieldId(subField) == 'ownedOutright') {
                                                switch (generatedFieldData) {
                                                    case false:
                                                    case 0:
                                                    case '0':
                                                        generatedFieldData = "0"
                                                        break;
                                                    case true:
                                                    case 1:
                                                    case '1':
                                                        generatedFieldData = "1"
                                                        break;
                                                    default:
                                                        break;
                                                }
                                            }

                                            if (!['0.aai.expenses_shared'].includes(`${key}.${this.getFieldId(subField)}`)) {
                                                _.set(generatedSubFieldData, `${key}.${this.getFieldId(subField)}`, generatedFieldData)
                                            }

                                            // console.warn('2', `${key}.${this.getFieldId(subField)}`, generatedFieldData)

                                        }
                                    }
                                })

                            } else {

                                // console.warn('here 1', this.getFieldId(subField))

                                let subFieldData = _.get(fieldData, `${field.field_mapping}.${subField.field_mapping}`, _.get(fieldData, subField.field_mapping, null))
                                let fieldId = this.getFieldId(subField)

                                if (['split', 'reference_address'].includes(subField.field_mapping)) {
                                    if (_.isEmpty(subFieldData) || _.isNull(subFieldData) || !subFieldData) {
                                        subFieldData = {}
                                    }
                                }

                                let fieldKey = fieldId.split('.')
                                if (_.size(fieldKey) > 1) {
                                    // check to see if the object key exists in field data, if not create it
                                    if (!_.has(generatedSubFieldData, fieldKey[0], false)) {
                                        _.set(generatedSubFieldData, fieldKey[0], {})
                                    }
                                    _.set(generatedSubFieldData[fieldKey[0]], fieldKey[1], subFieldData)
                                } else {
                                    _.set(generatedSubFieldData, fieldId, subFieldData)
                                }

                                if (['liability'].includes(subField.field_mapping_parent)) {
                                    if (['totalMonths'].includes(subField.field_mapping)) {
                                        if (_.isNull(generatedSubFieldData.totalMonths)) {
                                            _.set(generatedSubFieldData, fieldId, '360')
                                        }
                                        // console.warn('totalMonths', generatedSubFieldData)
                                    }
                                }



                                // console.warn('1', subFieldData)
                            }
                        }
                    }
                })
            }

            return generatedSubFieldData
        },

        currentGroupDescription(index, group) {
            if (_.has(this.currentGroup, "id", false) && _.kebabCase(group.title) == this.currentGroup.id && !_.isEmpty(this.currentGroup.description)) {
                return this.currentGroup.description
            }
            return group.description
        },

        setPathData(pathArray, data) {

            data = typeof data !== "undefined" || !_.isNull(data) ? data : null

            if (!_.isNull(data) && typeof data !== "undefined") {

                let pathString, pathKey, pathData
                if (_.size(pathArray) > 1) {

                    // get the last in the array to set as the key
                    pathKey = pathArray[_.size(pathArray) - 1]

                    // turn a comma seperated field mapping into an array
                    let pathKeyArray = pathKey.split(",")
                    if (![0, 1].includes(_.size(pathKeyArray))) {
                        pathKey = pathKeyArray.map(fieldMapping => fieldMapping.trim())
                    }

                    // remove the key from the array
                    pathArray.splice(_.size(pathArray) - 1)
                    pathString = pathArray.join('.')
                    pathData = _.get(this.formData, pathString, this.formData)

                    if (_.isArray(pathKey)) {
                        if (!_.isEmpty(pathKey)) {
                            pathKey.forEach(fieldKey => {
                                let currentData
                                if (_.isPlainObject(data[fieldKey])) {
                                    currentData = _.get(pathData, fieldKey, {})
                                    data[fieldKey] = _.merge(currentData, data)
                                } else if (_.isArray(data)) {
                                    currentData = _.get(pathData, fieldKey, [])
                                    data.forEach((newData, newDataKey) => {
                                        currentData[newDataKey] = newData
                                    })
                                    data[fieldKey] = currentData
                                }
                                Vue.set(pathData, fieldKey, data[fieldKey])
                            })
                        }
                    } else {
                        let currentData
                        if (_.isPlainObject(data)) {
                            currentData = _.get(pathData, pathKey, {})
                            data = _.merge(currentData, data)
                        } else if (_.isArray(data)) {
                            currentData = _.get(pathData, pathKey, [])
                            data.forEach((newData, newDataKey) => {
                                currentData[newDataKey] = newData
                            })
                            data = currentData
                        }

                        Vue.set(pathData, pathKey, data)
                    }
                } else {
                    pathString = pathArray.join('.')
                    let currentData

                    if (_.isPlainObject(data)) {
                        currentData = _.get(this.formData, pathString, {})
                        data = _.merge(currentData, data)
                        // } else if (_.isArray(data)) {
                        //     // currentData = _.get(this.formData, pathString, [])
                        //     // data.forEach((newData, newDataKey) => {
                        //     //     currentData[newDataKey] = newData
                        //     // })
                        //     // data = currentData
                    }
                    Vue.set(this.formData, pathString, data)
                }
            }

            return true
        }
    }
}
